export const RECIPIENTS_TOOLTIP_IDS = Object.freeze({
  rowActions: 'recipient-row-actions-tooltip',
  viewToggle: 'recipients-view-toggle-tooltip'
} as const)

export const BANK_RECIPIENT_ERROR_SUBSTITUTES: Record<string, string> = {
  postalCode: 'holderAddress.postalCode'
}
